import { Link } from "react-router-dom";
import useLocalization from '../../../hooks/use-localization';
import '../../../resources/css/post-micro.css';

export default function PostMicro({ post }) {

    const date = new Date(post.creationDate);
    const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    const dateRender = date.toLocaleDateString('uk-UA', dateOptions);

    const localization = useLocalization();

    const postPath = `/post/${post.id}`;

    return (
        <div className="post-micro">
            <div>
                <Link to={postPath}>
                    <img src={post.topImage} alt={post.topImage}></img>
                </Link>
            </div>
            <div>
                <div>
                    <Link to={postPath}>
                        {post.title}
                    </Link>
                </div>
                <div className="text-small">{dateRender} | {localization.author} {post.author}</div>
            </div>
        </div>
    )
}